import { INTERNATIONAL } from '@/constants/general-words.const';

export const toNumber = (number?: any) => {
  try {
    return number ? Number(number) : 0;
  } catch {
    return 0;
  }
};

export const toCurrency = (number?: number | string, showZeroDecimals: boolean = true): string => {
  try {
    if (number === undefined) {
      return '';
    }

    const formatted = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(number));
    const [integerPart, decimalPart] = formatted.split('.');

    if (!showZeroDecimals && decimalPart === '00') {
      return integerPart;
    }

    return formatted;
  } catch {
    return '';
  }
};

export const toBool = (value?: any): boolean => {
  try {
    return value === 'true' || value === 1 || value === true || value === '1';
  } catch {
    return false;
  }
};

export const toTitleCase = (value: string | undefined): string | undefined => {
  if (value) {
    // Replace first char of each word to UPPER case
    return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return value;
};

/* 
  Remove unwanted consecutive commas and normalize the input 
  input : a,   b,, , , c, d ,e,f 
  output: a, b, c, d, e, f
*/
export const normalizeCsv = (value: string | undefined): string | undefined => {
  if (value) {
    return value
      .replace(/(?:,\s*)+|(\w+)/g, (_, word) => (word ? word : ', '))
      .trim()
      .replace(/,\s*$/, ''); // remove trailing comma
  }

  return value;
};

export const toSafeDisplayPostcode = (postcode?: string): string => {
  if (postcode?.toUpperCase() === INTERNATIONAL.toUpperCase()) {
    return '';
  }
  return postcode ?? '';
};

export const toFormattedCardNumber = (cardNumber: string): string => {
  if (!cardNumber || typeof cardNumber !== 'string' || cardNumber.trim() === '') {
    return '';
  }

  return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
};

export const toMaskedCardNumber = (cardNumber: string | undefined, overrideCardlength?: number) => {
  if (cardNumber === undefined || cardNumber.length < 4) {
    return cardNumber;
  }
  const cardlength = overrideCardlength ? overrideCardlength : cardNumber.length;
  return cardNumber.slice(-4).padStart(cardlength, '*');
};
